<template>
	<PageArrows 
		v-bind:className="'patient'"
		v-bind:linkPrev="`/patient/${which}/${content[which].prevTab}`"
		v-bind:linkNext="`/patient/${which}/${content[which].nextTab}`"
		v-bind:linkNextInterim="content[which].nextTabInterim"
		v-bind:questionPopupDisplay="questionPopupDisplay"
		v-on:load-interim="loadInterim"
	></PageArrows>
	<ColumnLayout
		v-bind:which="which"
		v-bind:tabType="tabType"
		v-bind:content="content"
		v-bind:questionPopupDisplay="questionPopupDisplay"
		v-on:show-overlay="showOverlay"
	></ColumnLayout>
	<teleport to="body">
		<QuestionPopup
			v-if="content[which].InterimQA && questionPopupDisplay"
			v-bind:which="which"
			v-bind:tabType="tabType"
			v-bind:content="content"
			v-on:close-then="closeThen"
		></QuestionPopup>
	</teleport>
	<teleport to="body">
		<ScheduleExample
			v-if="content[which].ScheduleExample && scheduleExampleDisplay"
			v-bind:which="which"
			v-bind:tabType="tabType"
			v-bind:content="content"
			v-on:show-overlay="showOverlay"
		></ScheduleExample>
	</teleport>
</template>
<script>
import PageArrows from '@/components/PageArrows'
import ColumnLayout from '@/components/ColumnLayout'
import QuestionPopup from '@/components/QuestionPopup'
import ScheduleExample from '@/components/ScheduleExample'
export default {
	components: {
		PageArrows,
		ColumnLayout,
		QuestionPopup,
		ScheduleExample
	},
	data() {
		return {
			which: this.$route.params.which,
			tabType: 'ramp-up',
			questionPopupDisplay: false,
			scheduleExampleDisplay: false,
			content: {
				bishop: {
					prevTab: 'pre-initiation/',
					nextTab: 'final/',
					nextTabInterim: true,
					columnA: 313,
					columnAbutton: 232,
					columnButtonAction: 'show-schedule-example',
					columnAstyle: 'button-standalone',
					columnB: 307,
					columnC: 272,
					columnChide: true,
					InterimQA: {
						layoutClass: 'two-col checkboxes',
						type: 'checkbox',
						question: 'On Week 1 of venetoclax initiation, when would you monitor labs for a medium-risk patient like Mr. Bishop (select all that apply)?',
						choices: [
							'Pre-dose',
							'12 hours post-dose',
							'2−4 hours post-dose',
							'24 hours post-dose',
							'6−8 hours post-dose'
						],
						answer: -1,
						answerLong: 'Monitor labs pre-dose and 6–8 and 24 hours after the first dose on weeks 1–2 and pre-dose labs thereafter',
						answerSize: 957
					},
					ScheduleExample: {
						dirpath: 'patients',
						title: 'VEN+G INITIATION SCHEDULE EXAMPLE',
						title_sup: 1,
						tabs: {
							tab0: {
								name: "Low Tumor Burden",
								panels: [
									{
										img_main: 892,
										img_main_alt: 892
									},
									{
										img_main: 892
									}
								]
							},
							tab1: {
								name: "Medium Tumor Burden",
								panels: [
									{
										img_main: 892,
										img_main_alt: 892
									},
									{
										img_main: 892
									}
								]
							},
							tab2: {
								name: "High Tumor Burden",
								panels: [
									{
										img_main: 892,
										img_main_alt: 892
									},
									{
										img_main: 892
									}
								]
							}
						}	
					}
				}
			}
		}
	},
	methods: {
		loadInterim(){
			this.questionPopupDisplay = true
		},
		closeThen(){
			this.questionPopupDisplay = false
			this.content[this.which].columnChide = false
			this.content[this.which].nextTabInterim = false
		},
		showOverlay(whichActions){
			switch(whichActions[0]){
				case 'show-overlay':
						this.overlayDisplay = whichActions[1]
					break;
				case 'show-schedule-example':
						this.scheduleExampleDisplay = whichActions[1]
					break;

			}
		}
	}
}
</script>